import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import {
  PaymentGatewayInitializeRequestDTO,
  PaymentGatewayInitializeResponseDTO,
  PaymentGatewayTransactionCreateRequestDTO,
  PaymentGatewayTransactionDTO,
  PaymentGatewayTransactionList,
  PaymentGatewayTransactionReadByGatewayOrderIdRequestDTO,
  PaymentGatewayTransactionReadByGatewayTransactionIdRequestDTO,
  PaymentGatewayTransactionReadByIdRequestDTO,
  PaymentGatewayTransactionReadByModuleIdRequestDTO,
  PaymentGatewayTransactionUpdateRequestDTO,
  InitializeCashPaymentDTO
} from "./paymentGateway.service";

import {
  PaymentGateway_InitializePaymentGateway,
  PaymentGatewayTransaction_Create,
  PaymentGatewayTransaction_Update,
  PaymentGatewayTransaction_ReadById,
  PaymentGatewayTransaction_ReadByModuleId,
  PaymentGatewayTransaction_ReadByGatewayOrderId,
  PaymentGatewayTransaction_ReadByGatewayTransactionId,
  PaymentGateway_InitializeCashPayment
} from "src/app/GlobalVariable";

@Injectable({
  providedIn: "root",
})
export class PaymentGatewayService {
  private http = inject(HttpClient);

  PaymentGateway_InitializePaymentGateway(
    data: PaymentGatewayInitializeRequestDTO
  ): Observable<PaymentGatewayInitializeResponseDTO> {
    return this.http.post<PaymentGatewayInitializeResponseDTO>(
      PaymentGateway_InitializePaymentGateway,
      data
    );
  }

  PaymentGatewayTransaction_Create(
    data: PaymentGatewayTransactionCreateRequestDTO
  ): Observable<PaymentGatewayTransactionDTO> {
    return this.http.post<PaymentGatewayTransactionDTO>(
      PaymentGatewayTransaction_Create,
      data
    );
  }

  PaymentGatewayTransaction_Update(
    data: PaymentGatewayTransactionUpdateRequestDTO
  ): Observable<PaymentGatewayTransactionDTO> {
    return this.http.post<PaymentGatewayTransactionDTO>(
      PaymentGatewayTransaction_Update,
      data
    );
  }

  PaymentGatewayTransaction_ReadById(
    data: PaymentGatewayTransactionReadByIdRequestDTO
  ): Observable<PaymentGatewayTransactionDTO> {
    return this.http.post<PaymentGatewayTransactionDTO>(
      PaymentGatewayTransaction_ReadById,
      data
    );
  }

  PaymentGatewayTransaction_ReadByModuleId(
    data: PaymentGatewayTransactionReadByModuleIdRequestDTO
  ): Observable<PaymentGatewayTransactionList> {
    return this.http.post<PaymentGatewayTransactionList>(
      PaymentGatewayTransaction_ReadByModuleId,
      data
    );
  }

  PaymentGatewayTransaction_ReadByGatewayOrderId(
    data: PaymentGatewayTransactionReadByGatewayOrderIdRequestDTO
  ): Observable<PaymentGatewayTransactionDTO> {
    return this.http.post<PaymentGatewayTransactionDTO>(
      PaymentGatewayTransaction_ReadByGatewayOrderId,
      data
    );
  }

  PaymentGatewayTransaction_ReadByGatewayTransactionId(
    data: PaymentGatewayTransactionReadByGatewayTransactionIdRequestDTO
  ): Observable<PaymentGatewayTransactionDTO> {
    return this.http.post<PaymentGatewayTransactionDTO>(
      PaymentGatewayTransaction_ReadByGatewayTransactionId,
      data
    );
  }

PaymentGateway_InitializeCashPayment(
  data: InitializeCashPaymentDTO
): Observable<PaymentGatewayTransactionDTO> {
  return this.http.post<PaymentGatewayTransactionDTO>(
    PaymentGateway_InitializeCashPayment,
    data
  );
}


}